import { module } from 'angular';

import listResultsComponent from './results/list-results.component';
import listItemNameComponent from './item-name/list-item-name.component';
import listPreviewComponent from './preview/list-preview.component';

export default module('app.list', [])
	.component('listResults', listResultsComponent)
	.component('listItemName', listItemNameComponent)
	.component('listPreview', listPreviewComponent)
	.name;
